import { render, staticRenderFns } from "./ListRegistration.vue?vue&type=template&id=2b62050c"
import script from "./ListRegistration.vue?vue&type=script&lang=js"
export * from "./ListRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports